/* client/src/components/Login.tsx */
import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  Alert,
  Link,
  CircularProgress
} from '@mui/material';
import { apiLogin } from '../services/apiService';

interface LoginProps {
  onLogin: (user: any) => void;
  onShowRegister?: () => void;
}

function Login({ onLogin, onShowRegister }: LoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      console.log('Login attempt with:', { email, password });
      const data = await apiLogin(email, password);
      console.log('Login API response:', data);
      
      // UPDATED: Check only for user data (token is in HTTP-only cookie)
      if (data.user) {
        console.log('Login successful, calling onLogin...');
        onLogin(data.user); // REMOVED token parameter
      } else {
        console.error('Invalid response structure:', data);
        setError('Invalid server response - missing user data');
      }
    } catch (err: any) {
      console.error('Login error details:', err);
      setError(err.message || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onShowRegister) {
      onShowRegister();
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          MNC Accounting
        </Typography>
        
        <Typography variant="h6" component="h2" gutterBottom align="center" color="textSecondary">
          Sign in to your account
        </Typography>
        
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          
          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
          
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 3 }}
            disabled={loading}
          >
            {loading ? (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Signing in...
              </Box>
            ) : (
              'Sign In'
            )}
          </Button>

          {/* Conditionally render registration link */}
          {onShowRegister && (
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Typography variant="body2">
                Don't have an account?{' '}
                <Link 
                  href="#" 
                  onClick={handleRegisterClick}
                  sx={{ cursor: 'pointer' }}
                >
                  Sign up
                </Link>
              </Typography>
            </Box>
          )}
        </Box>
        
        <Typography variant="body2" sx={{ mt: 3, textAlign: 'center' }}>
         
        </Typography>
      </Paper>
    </Container>
  );
}

export default Login;